<template>
  <div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AskapriceStylesComponent extends Vue {}
</script>

<style lang="scss">
  @import "../../assets/scss/askaprice/main";
</style>
